module.exports = __webpack_public_path__ + "img/mapLegend.b0bdeb61.svg";